import * as React from 'react';

import type {Lead as LeadFragment, SessionUser} from 'nutshell-graphql-types';

import {LeadTagsEditor} from '../../shared/components/lead-tags-editor';

import {LeadButtons} from './lead-buttons';
import {LeadIcon} from './lead-icon';
import {LeadNameContainer} from './lead-name-container';
import {LeadValue} from './lead-value';

import styles from './lead-header-left.module.css';

type Props = {
    lead: LeadFragment;
    user: SessionUser | null | undefined;
    onUpdateLeadName: (arg1: string) => Promise<any>;
    fetchTags: (arg1: string) => Promise<any>;
    showButtons?: boolean;
    showValue?: boolean;
};

export function LeadHeaderContainer(props: Props) {
    const {lead, onUpdateLeadName} = props;

    return (
        <div className={styles['header-container']}>
            <LeadIcon
                id={lead.id}
                status={lead.status}
                number={lead.number}
                avatarUrl={lead.avatarUrl}
            />
            <div className={styles['title-container']}>
                <LeadNameContainer lead={lead} onUpdateLeadName={onUpdateLeadName} />
                <LeadTagsEditor lead={props.lead} user={props.user} fetchTags={props.fetchTags} />
            </div>
            {props.showValue === false ? null : (
                <LeadValue isHot={lead.isHot} status={lead.status} value={lead.value} />
            )}
            {props.showButtons === false ? null : <LeadButtons leadId={lead.id} />}
        </div>
    );
}
